import React from 'react';
import { DataGrid } from '../../common/datagrid/ResponsiveDataGrid';
import CustomLoadingOverlay from '../../common/datagrid/CustomLoadingOverlay';
import CustomToolbar from '../../common/datagrid/CustomToolbar';

const EstimateList = ({ columns, rows, loading,handleRowClick, columnVisibilityModel }) => {
  return (
    <div style={{ display: 'flex', height: '350px' ,  minWidth: '100%' }}>
      <div style={{ flexGrow: 1,  minWidth: '100%'  }}>
        <DataGrid
          rows={rows ? rows : []}
          columns={columns}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: '견적서리스트' },
          }}
          loading={loading}
          autoPageSize
          pagination
          onRowClick={handleRowClick}
          columnVisibilityModel={columnVisibilityModel? columnVisibilityModel: []}
        />
      </div>
    </div>
  );
};

export default EstimateList;
